exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-sp-components-molecules-Header-___Header__title___24mwj {\n  margin-bottom: 8px;\n}\n\n  .src-sp-components-molecules-Header-___Header__title___24mwj > p {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n\n.src-sp-components-molecules-Header-___Header__participantCount___Xirt0 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n", ""]);

// exports
exports.locals = {
	"title": "src-sp-components-molecules-Header-___Header__title___24mwj",
	"participantCount": "src-sp-components-molecules-Header-___Header__participantCount___Xirt0"
};